module.exports = __webpack_public_path__ + "static/img/1煤炭.88b0cd1b.jpg";